import moment from "moment";

export const formatDisplayedDate = (value, formatDisplay) => {
  return moment(value).format(formatDisplay);
};

export const formatValueDate = (value, formatValue) => {
  if (typeof formatValue === "string") {
    return moment(value).format(formatValue);
  }
  if (typeof formatValue === "function") {
    return formatValue(value);
  }
  return value;
};

export const formatRangeLabel = (start, end) => {
  if (!start || !end) {
    return "";
  }
  const s = moment(start).format("ll");
  const e = moment(end).format("ll");
  return `${s} - ${e}`;
};
